import { CallButton } from "@app/components/Call-btn";
import { DetailsButton } from "@app/components/Details-btn";
import { DriverProfile } from "@app/components/Driver-Profile";
import { EventBox } from "@app/components/events-box";
import { Status } from "@app/components/Status";
import { RootState } from "@app/store";
import { memo } from "react";
import { useSelector } from "react-redux";
import { Footer, FooterWarper } from "./mainBottom.styles";


type OndemandSectionBottomProps = {
  orderCode: string;
  vehicleTypeIcon?: string;
};

type PDSectionBottomProps = {};

export const MainBottom = () => {
  
  const orderType = useSelector((state: RootState) => state.order.type);
  const orderCode = useSelector((state: RootState) => state.order.code);
  const vehicleTypeIcon = useSelector((state: RootState) => state.service.vehicle?.icon);

  return (
    <Footer height={orderType === "Ondemand" ? "195px" : "177px"}>
      <Status />
      <FooterWarper>
        {orderType === "Ondemand" ? (
          <OndemandSectionBottom
            orderCode={orderCode}
            vehicleTypeIcon={vehicleTypeIcon}
          />
        ) : (
          <PDSectionBottom />
        )}
      </FooterWarper>
    </Footer>
  );
};

const OndemandSectionBottom = ({
  orderCode,
  vehicleTypeIcon,
}: OndemandSectionBottomProps) => {
  const driver = useSelector((state: RootState) => state.order.driver);

  return (
    <>
      {driver ? (
        <DriverProfile
          avatarPhoto={driver.avatarPhoto}
          name={driver.name}
          rate={driver.rate}
          vehicleTypeIcon={vehicleTypeIcon}
          vehiclePlate={driver.vehicle.plate}
          vehicleColor={driver.vehicle.color}
          vehicleModel={driver.vehicle.model}
          height="58px"
        />
      ) : null}

      <div
        style={{
          float: "left",
          display: "flex",
          width: "100%",
        }}
      >
        <CallButton phone={driver?.phone} customStyles={{ marginLeft: "0" }} />
        <DetailsButton />
      </div>
    </>
  );
};

const PDSectionBottom = ({}: PDSectionBottomProps) => {
  const events = useSelector(
    (state: RootState) => state.order.events[state.order.events.length - 1]
  );

  return (
    <>
      {events && <EventBox
        title={events.title}
        description={events.description}
        createdAt={events.createdAt}
      />}

      <DetailsButton />
    </>
  );
};



export const MemoMainBottom = memo(MainBottom) 